import { Box, Text } from '@chakra-ui/react'
import { FieldMapValue } from '@hb/shared'

export const ClinicalRationaleView = ({ data }: { data: FieldMapValue }) => {
  const clinicalRelationship = data?.clinicalRelationshipToPregnancy as string | undefined

  return (
    <Box w="100%" pt={1}>
      <Text fontSize="sm" fontWeight={600} color="gray.600" mb={1}>
        Clinical Relationship to Pregnancy
      </Text>
      {clinicalRelationship ? (
        <Text fontSize="sm" whiteSpace="pre-wrap">
          {clinicalRelationship}
        </Text>
      ) : (
        <Text fontSize="sm" fontStyle="italic" color="gray.500">
          Not recorded
        </Text>
      )}
    </Box>
  )
}
